// var productCardMarkup = 
//   `<div class="swym-wishlist-grid">
// 		{{#products}} 
//     <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
// 		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
// 		<div class="swym-title swym-title-1">
// 			{{dt}}
// 		</div></button>
// 		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
// 			{{variantinfo}}
// 		</div>
// 		<div class="swym-product-price swym-text swym-text-1">
// 			<div class="swym-product-final-price swym-value">
// 				{{cu}}{{pr}}
// 			</div>
//         </div>
// 		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
// 			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to bag{{/isInCart}}
// 		</button>
//     </a> 
//        {{/products}}
// 	</div>`;

var productCardMarkup = 
  `<div class="swym-wishlist-grid">

		{{#products}} 

      <div class="swym-wishlist-grid-item d-flex" data-variant-id="{{epi}}">

        <div class="swym-wishlist-image-wrapper">
          <a href="{{du}}" aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"> 
            <img alt="" class="swym-wishlist-image" src="{{iu}}">
          </a>
        </div>
        <div class="swym-wishlist-info">
          <a href="{{du}}" class="swym-title swym-title-1">
            {{dt}}
          </a>
          <div class="yotpo-wrapper">
            <div class="yotpo bottomLine" data-product-id="{{empi}}" data-url="{{du}}"></div>
          </div>
        </div>
        <div class="swym-wishlist-action">

          <div class="swym-product-price swym-text swym-text-1">
            <div class="swym-product-final-price swym-value">
              {{cu}}{{pr}}
            </div>
          </div>

          <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 10H24V25C24 25.5523 23.5523 26 23 26H9C8.44772 26 8 25.5523 8 25V10Z" stroke="black"></path><rect x="5" y="9.5" width="22" height="1" fill="black"></rect><path d="M14 14L14 22L13 22L13 14L14 14Z" fill="black"></path><path d="M19 14L19 22L18 22L18 14L19 14Z" fill="black"></path><path d="M13 10V7C13 6.44772 13.4477 6 14 6H18C18.5523 6 19 6.44772 19 7V10" stroke="black"></path></svg>
          </button>

          <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
            {{#isInCart}}Added to bag{{/isInCart}}{{^isInCart}}Add to bag{{/isInCart}}
          </button>
        
        </div>

      </div>

    {{/products}}

	</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}


let swymShareLink, swymListId;


if(location.href.includes('?lid')) {
  swymListId = location.href.split('?lid=')[1];
  document.querySelector('.wishlist-content-main').classList.add('shared-list');
  window.SwymCallbacks.push(swymRenderSharedList);
}
else {
  window.SwymCallbacks.push(swymRenderWishlist);
  window.SwymCallbacks.push(swymFetchList);
}

window.SwymCallbacks.push(swymRenderCustomFunc); 
window.SwymCallbacks.push(updateCart);

function swymFetchList(swat) {
  swat.fetchLists({
    callbackFn: function(lists) {
      swymListId = lists[0].lid;
      // swat.generateSharedListURL(swymListId, swymGenarateCopyLink);
    } 
  });
}

function swymGenarateCopyLink(link, lid) {
  swymShareLink = link;
}

function swymRenderWishlist(swat) {
  // Get wishlist items
	swat.fetch(function(products) {
    swymRenderWishlistContents(products);
	});
}

function swymRenderSharedList(swat) {
  let listConfig = {
    lid: swymListId
  }
  swat.fetchListDetails(listConfig, swymFetchSharedList);
}

function swymFetchSharedList(listDetails) {
  swymRenderWishlistContents(listDetails.items);
}

function swymRenderWishlistContents(products) {
  var mainCont = document.querySelector('.wishlist-content-main');
  var emptyCont = document.querySelector('.wishlist-content-empty');
  var headerIcon = document.querySelector('.header-nav-link-wrapper .swym-wishlist');
  var itemCount = document.querySelectorAll('.wishlist-item-count');

  if(products.length > 0) {
    mainCont.classList.remove('hidden');
    emptyCont.classList.add('hidden');
    headerIcon.classList.add('has-list');
  }
  else {
    mainCont.classList.add('hidden');
    emptyCont.classList.remove('hidden');
    headerIcon.classList.remove('has-list');
  }
  itemCount.forEach((count) => {
    count.innerText = products.length;
    count.classList.remove('hidden');
  })

  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  var formattedWishlistedProducts = products.map(function(p) {
    p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
    p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
    p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
    return p;
  });
  var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
    products: formattedWishlistedProducts
  });
  if(wishlistContentsContainer){
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
  } else{
    console.log("Container not found, Wishlist Page element not found");
  }

  setTimeout(() => {
    var api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  }, 500);

}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
  var state = e.currentTarget.getAttribute('data-state-cart');
	// e.target.innerHTML = "Adding..";

  if(state == 'swym-added') {
    fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => {
      // document.body.classList.add('ajax-cart-is-open');
      document.dispatchEvent(new CustomEvent('ajaxcart:open'));
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return;
  }
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to bag";
		e.target.setAttribute("data-state-cart", "swym-added");

    document.body.classList.add('ajax-cart-is-open');
    document.dispatchEvent(new CustomEvent('ajaxcart:open'));

		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to bag Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderCustomFunc() {
  var el = {
    item: '.swym-wishlist-grid-item',
    add_ilst_to_cart: '.wishlist-items-footer .add-list-to-cart',
    clear_list: '.wishlist-items-footer .clear-list'
  }

  var elAddListToCart = document.querySelector(el.add_ilst_to_cart);
  var elClearCart = document.querySelector(el.clear_list);

  // When Add all items to bag is clicked.
  elAddListToCart.addEventListener('click', () => {
    let items = [];
    document.querySelectorAll(el.item).forEach((item) => {
      items.push({
        id: item.getAttribute('data-variant-id'),
        quantity: 1
      });
    })
    let formData = {
      'items': items
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      //  return response.json();
      document.body.classList.add('ajax-cart-is-open');
      document.dispatchEvent(new CustomEvent('ajaxcart:open'));
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  })

  // When Empty my bag is clicked.
  elClearCart.addEventListener('click', () => {
    // var xhttp = new XMLHttpRequest();
    // xhttp.open("POST", "/cart/clear.js", true);
    // xhttp.send();
    // xhttp.onreadystatechange = function() {
    //   if (this.readyState == 4 && this.status == 200) {
    //     document.body.classList.add('ajax-cart-is-open');
    //     document.dispatchEvent(new CustomEvent('ajaxcart:open'));
    //   }
    // }
    document.querySelectorAll('.swym-wishlist-grid-item').forEach((item) => {
      item.querySelector('#swym-remove-productBtn').click();
    })
  })
}

function updateCart() {
  let observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.initiatorType == "xmlhttprequest") {
        if(entry.name.includes('/cart/update.js')) {
          window.SwymCallbacks.push(swymRenderWishlist);
        }
        else if(entry.name.includes('/recordWishlistAction') || entry.name.includes('/epiRecordWishlist')) {
          window.SwymCallbacks.push(swymRenderWishlist);
        }
      }
    }
  });
  observer.observe({entryTypes: ["resource"]});
}

document.querySelector('.share-wishlist').addEventListener('click', () => {

  let swymCustomShareLink = `${location.href}?lid=${swymListId}`
  // navigator.clipboard.writeText(swymShareLink);
  navigator.clipboard.writeText(swymCustomShareLink);

  console.log("Share link....", swymCustomShareLink)
  document.querySelector('.swym-notification').classList.add('active');
  setTimeout(() => {
    document.querySelector('.swym-notification').classList.remove('active');
  }, 2000);
})